// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchTextboxColour {\n  border-width: 2px;\n  border-color: #062bd1;\n}", "",{"version":3,"sources":["webpack://src/pages/CommonPage/Search.scss"],"names":[],"mappings":"AACA;EAEI,iBAAA;EACC,qBAAA;AADL","sourcesContent":["\n.searchTextboxColour\n{\n    border-width: 2px;\n     border-color: #062bd1;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
